import React from 'react';
import { useTranslation } from 'react-i18next';
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

// L'AJUDA DEL LLENÇ D'ESTOCS I FLUXOS.
//
// El text no descriu botons: descriu **la notació**, que és el que costa d'aprendre. Les dues
// menes de fletxa i la llei que les separa —un estoc només canvia pels fluxos— són el gruix del
// que aquí s'ha d'entendre, i és també el que fa que el llenç rebutgi certes fletxes.
//
// Com a `HelpModal`, el contingut és una estructura i el marcatge una sola volta: tot el text
// surt del diccionari i no n'hi ha ni una cadena escrita entre etiquetes.

const Ratlla = ({ etiqueta, cos }) => (
  <div className="flex items-start gap-2">
    <span className="font-medium text-gray-900 w-32 flex-shrink-0">{etiqueta}</span>
    <span className="text-gray-700">{cos}</span>
  </div>
);

const Seccio = ({ titol, children }) => (
  <section className="mb-6">
    <h4 className="text-sm font-semibold text-gray-900 mb-3 uppercase tracking-wider">{titol}</h4>
    <div className="space-y-2 text-sm">{children}</div>
  </section>
);

const AjudaEstocs = ({ onTancar }) => {
  const { t } = useTranslation();
  const ratlles = (parells) => parells.map(([e, c]) => (
    <Ratlla key={`${e}-${c}`} etiqueta={t(`sfAjuda.${e}`)} cos={t(`sfAjuda.${c}`)} />
  ));

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50" onClick={onTancar} />
        <div className="relative bg-white rounded-md shadow-xl max-w-2xl w-full">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <div className="flex items-center gap-2">
              <InformationCircleIcon className="h-5 w-5 text-primary-700" />
              <h3 className="text-base font-semibold text-gray-900">{t('sfAjuda.title')}</h3>
            </div>
            <button type="button" onClick={onTancar} aria-label={t('help.close')}
              className="text-gray-400 hover:text-gray-600 p-1 rounded-md hover:bg-gray-100">
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          <div className="px-6 py-5 max-h-[70vh] overflow-y-auto">
            <Seccio titol={t('sfAjuda.pieces')}>
              {ratlles([['stock', 'stockBody'], ['init', 'initBody'], ['converter', 'converterBody'],
                        ['cloud', 'cloudBody']])}
            </Seccio>
            <Seccio titol={t('sfAjuda.arrows')}>
              {ratlles([['pipe', 'pipeBody'], ['connector', 'connectorBody'], ['units', 'unitsBody']])}
            </Seccio>
            <Seccio titol={t('sfAjuda.rules')}>
              {ratlles([['law', 'lawBody'], ['clouds', 'cloudsBody'], ['valve', 'valveBody'],
                        ['time', 'timeBody'], ['endogen', 'endogenBody']])}
            </Seccio>
            <Seccio titol={t('sfAjuda.sim')}>
              {ratlles([['simFill', 'simFillBody'], ['simArrow', 'simArrowBody'],
                        ['simThick', 'simThickBody'], ['simDots', 'simDotsBody'],
                        ['simNeg', 'simNegBody'], ['simNo', 'simNoBody'], ['div', 'divBody']])}
            </Seccio>
            <Seccio titol={t('sfAjuda.mouse')}>
              {ratlles([['draw', 'drawBody'], ['arrow', 'arrowBody'], ['move', 'moveBody'],
                        ['del', 'delBody'], ['rename', 'renameBody'],
                        ['zoom', 'zoomBody'], ['pdf', 'pdfBody']])}
            </Seccio>
            <p className="text-xs text-gray-500 border-t border-gray-200 pt-3">{t('sfAjuda.noEngine')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AjudaEstocs;
